
import dayjs from 'dayjs'
import '@/assets/scss/2_component/_product.scss'
import { pdMixin } from '@/mixin/pd/pdMixin'
import { isShowTotalSelling } from '~/config/options'
import { convertCdnResizeUrl } from '@/utils'
import ThumbOverlay from '@/components/common/product/ThumbOverlay.vue'
import BoxPdEmblem from '~/components/common/product/BoxPdEmblem.vue'
import BoxPdFlag from '~/components/common/product/BoxPdFlag.vue'
import HolidayDeliveryFlag from '~/components/common/product/HolidayDeliveryFlag.vue'
import ProdPrice from '@/components/common/product/ProdPrice.vue'
import ProdName from '@/components/common/product/ProdName.vue'
import ProdEmblem from '@/components/common/product/ProdEmblem.vue'
import ProdNumber from '@/components/common/product/ProdNumber.vue'
import ProdFlag from '@/components/common/product/ProdFlag.vue'
import ProdOption from '@/components/common/product/ProdOption.vue'
import ProdRating from '@/components/common/product/ProdRating.vue'
import ProdRelease from '@/components/common/product/ProdRelease.vue'
import ShoppingbagButton from '@/components/common/product/ShoppingbagButton.vue'
import { rules } from '~/mixin/common/product/productRules'
import CommonImage from '~/components/common/CommonImage.vue'
import { getCapturedImageUrl, getResizedImgUrl } from '~/scriptData/common/interM2'
import { groobeeUtil } from '~/mixin/groobeeUtil'

export default {
  components: {
    CommonImage,
    BoxPdFlag,
    BoxPdEmblem,
    HolidayDeliveryFlag,
    ThumbOverlay,
    ProdPrice,
    ProdName,
    ProdEmblem,
    ProdNumber,
    ProdFlag,
    ProdOption,
    ProdRating,
    ProdRelease,
    ShoppingbagButton
  },
  mixins: [pdMixin, rules, groobeeUtil],
  props: {
    item: {
      type: [Array, Object],
      default: () => {
        return {}
      }
    },
    index: {
      type: Number,
      default: 0
    },
    unitType: {
      type: String,
      default: 'general'
    },
    viewCard: {
      type: Boolean,
      default: true
    },
    cart: {
      type: Boolean,
      default: true
    },
    rcmd: { // 추천솔루션 (z.Ai) 여부
      type: Boolean,
      default: false
    },
    bundle: { // 세트상품 여부
      type: Boolean,
      default: false
    },
    editChk: { // 체크박스 활성화 여부
      type: Boolean,
      default: false
    },
    editRestock: { // 재입고알림 관리 (썸네일 밖 체크박스/재입고알림 신청 취소)
      type: Boolean,
      default: false
    },
    storeEditReStock: { // 매장 재입고알림 관리
      type: Boolean,
      default: false
    },
    opRunNtcn: { // 판매시작알림 관리
      type: Boolean,
      default: false
    },
    status: { // 리뷰 작성 상태
      type: String,
      default: 'before'
    },
    showHolidayFlag: {
      type: Boolean,
      default: false
    },
    groobeeRecmData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      isShowTotalSelling,
      ctenZzim: '', // 컨텐츠 스크랩 여부
      isZzim: '', //
      pdAnc: '', // 상품 알람신청 여부
      checkState: false,
      adltCtfcYn: this.$store.getters['session/getAdltCtfcYn'], // 성인인증 여부
      delPdData: [], // 삭제할 재입고알림상품
      spbkSeCd: '01'
    }
  },
  computed: {
    anc: {
      get () {
        return this.isNotEmpty(this.pdAnc) ? this.pdAnc : this.item.pdAnc
      },
      set (val) {}
    },
    zzim: {
      get () {
        return this.isNotEmpty(this.ctenZzim) ? this.ctenZzim : this.item.isZzim
      },
      set (val) {}
    },
    restock () {
      // 판매중인 상태에서 솔드아웃일 때 재입고 예정
      if (this.isNotEmpty(this.item.sleStsCd) && this.isNotEmpty(this.item.soldout)) {
        return this.item.sleStsCd === '03' && this.item.soldout
      } else {
        return false
      }
    },
    stopsale () {
      // 판매중지/ 판매종료 상태(판매준비도 포함하지만 판매준비상태는 상품정보가 없으므로 노출되는건 중지와 종료만 있음)
      return this.item.sleStsCd === '01' || this.item.sleStsCd === '04' || this.item.sleStsCd === '05'
    },
    showCart () {
      // 장바구니 버튼 노출 조건 (재입고 아니고 판매예정 아니고 상품권 아님)
      return this.cart && !this.stopsale && !this.restock && this.item.sleStsCd !== '02' && this.item.pdTy !== '03'
    },
    rating () {
      // rating 영역 노출 여부
      return this.item.most || this.isNotEmpty(this.item.revwAvg) || this.isNotEmpty(this.item.revwCnt) || this.isNotEmpty(this.item.totOrQy)
    },
    revwRating () {
      // 리뷰 노출 조건 체크
      if (this.isNotEmpty(this.item.revwAvg) && this.isNotEmpty(this.item.revwCnt)) {
        return this.rating && this.item.revwCnt >= 10 && parseFloat(this.item.revwAvg) >= 1
      } else {
        return false
      }
    },
    flagTop () {
      // top flag 노출 여부
      return this.item.bundle || this.item.onlyPkup
    },
    flagArea () {
      // flag area 노출 여부
      return this.item.newPdYn || this.item.onlyOnlYn
    },
    checkVal: {
      get () {
        return this.item.checked
      },
      set (val) {
        this.$emit('toggle-chk', {
          id: this.index,
          checked: val
        })
      }
    },
    openRunTime () {
      const opTime = dayjs(this.item.sleStDtm).format('YYYY-MM-DD HH:mm:ss')
      let opRunTime = ''
      let amPm = ''

      if (this.isNotEmpty(opTime)) {
        const week = ['일', '월', '화', '수', '목', '금', '토']
        const month = new Date(opTime).getMonth() + 1
        const date = new Date(opTime).getDate()
        let time = new Date(opTime).getHours()
        const dayOfWeek = week[new Date(opTime).getDay()]
        if (time < 12) {
          amPm = '오전'
        } else {
          amPm = '오후'
          if (time !== 12) {
            time -= 12
          }
        }

        opRunTime = month + '/' + date + '(' + dayOfWeek + ')' + ' ' + amPm + ' ' + time + '시'
      }
      return opRunTime
    },
    setSleStDtm () {
      let sleStDtm = ''

      if (this.isNotEmpty(this.item.sleStDt)) {
        sleStDtm = this.item.sleStDt
      } else if (this.isNotEmpty(this.item.SLE_ST_DTM)) {
        sleStDtm = this.item.SLE_ST_DTM
      }

      return sleStDtm
    },
    holidayDeliveryInfo () {
      return this.$store.getters['ds/getHolidayDeliveryInfo']
    },
  },
  watch: {
  },
  created () {
    this.check = this.item.isZzim === 'Y'
  },
  mounted () {
    this.setSpbkSeCd() // 장바구니 설정
  },
  methods: {
    getResizedImgUrl,
    getCapturedImageUrl,

    convertCdnResizeUrl (url, resize) {
      return convertCdnResizeUrl(url, resize)
    },

    toggleChk (event) {
      this.$emit('toggle-chk', {
        id: this.item.id, // 인덱스
        checked: event
      })
    },

    moveLink () {
      if (this.storeEditReStock && !this.isNotEmpty(this.item.imgUrl)) {
        return
      }
      let routeObj = {}

      if (this.groobeeRecmData && this.groobeeRecmData.pdRecmNoList?.length > 1) {
        const goods = []

        goods.push({ goodsCd: this.isNotEmpty(this.item.grpPdNo) ? this.item.grpPdNo : this.item.pdNo })

        this.sendGroobee('prod', this.groobeeRecmData.algorithmCd, this.groobeeRecmData.campaignKey, goods, 'CL')
      }

      if (this.unitType === 'contwriter') {
        if (this.item.txtLength === '1') {
          routeObj = { path: '/ug/ugd/SCR_UGD_0007', query: { ctenId: this.item.ctenId } }
        } else if (this.item.txtLength === '2') {
          routeObj = { path: '/ug/ugd/SCR_UGD_0014', query: { ctenId: this.item.ctenId } }
        } else {
          routeObj = { path: '/ug/ugd/SCR_UGD_0019', query: { ctenId: this.item.ctenId } }
        }
        this.$router.push(routeObj)
      } else if (this.item.sleStsCd !== '01' && this.item.sleStsCd !== '05') {
        // 판매준비, 판매 종료 상품 상세 이동 불가
        this.moveRoutePdDtlPage({ pdNo: this.isNotEmpty(this.item.grpPdNo) ? this.item.grpPdNo : this.item.pdNo, recmYn: this.rcmd ? 'Y' : 'N' }) // 상품상세 이동
      }
    },

    // 컨텐츠 스크랩(찜) 이벤트
    async updCtenZzim (item) {
      if (!this.isLogin) {
        item.ctenZzim = false
        // 로그인 체크
        this.$router.push({ name: 'mb-mbb-SCR_MBB_0097A', params: { returnUrl: this.$route.fullPath } })
        return false
      } else {
        console.log(item)
        await this.$AxiosBuilder
          .data({
            ctenId: item.ctenId,
            lgnMbMngNo: this.mbMngNo,
            avtTy: 'S',
            zzimActTy: !item.zzim ? 'P' : 'M' // 스크랩 : 스크랩 취소
          })
          .build()
          .post('/ug/common/updCtenZzim')
          .then((res) => {
            if ((!res.data.data.success && res.data.data.returnCode === '-1')) {
              this.ctenZzim = false
              this.$confirm(this.$t('UG.REG_PROFILE_FOR_SCRAP'), {
                center: true,
                dangerouslyUseHTMLString: true
              }).then(() => {
                this.$router.push({ name: 'ug-ugp-SCR_UGP_0018', params: { returnUrl: window.location.href } })
              }).catch(() => {
                return false
              })
            } else if (!res.data.success) {
              this.ctenZzim = false
            } else {
              this.ctenZzim = !item.zzim
              const msg = this.ctenZzim ? this.$t('UG.SCRAP_SUCCESS') : this.$t('UG.SCRAP_CANCEL') // 콘텐츠를 스크랩했습니다. / 스크랩을 해제했습니다.
              this.openToast(msg)
            }
          }).catch((e) => {
            console.log('pdUnitCmp ctenZzim error : ', e)
          })
      }
    },

    // 장바구니
    async goCart () {
      console.log('pkgYn ===', this.item.pkgYn, 'pkgEpieceSleYn ===', this.item.pkgEpieceSleYn)
      if (!this.isLogin) {
        // 로그인 체크
        this.$router.push({ name: 'mb-mbb-SCR_MBB_0097A', params: { returnUrl: this.$route.fullPath } })
        return
      }
      // 상품 유닛에서 호출하는 장바구니는 택배상품을 기준으로 함(옵션 여부에 따라 상품상세 이동)
      if (this.item.optPdYn) {
        // 옵션이 있는 상품입니다. 상품상세에서 옵션을 선택해주세요.
        this.confirm(this.$t('PD.CART_OPTION'), {
          okCallback: () => {
            this.moveRoutePdDtlPage({ pdNo: this.item.pdNo }) // 상품상세 이동
          }
        })
      } else if (this.item.pkgYn === 'Y' && this.item.pkgEpieceSleYn === 'N') { // 덕용상품이고, 낱개판매 안할때
        // 수량 옵션이 있는 상품입니다. 상품상세에서 수량 옵션을 선택해주세요.
        this.confirm(this.$t('PD.CART_QY_OPTION'), {
          okCallback: () => {
            this.moveRoutePdDtlPage({ pdNo: this.item.pdNo }) // 상품상세 이동
          }
        })
      } else {
        const pdNo = this.item.bundle ? '' : (this.item.pdTy !== '06' ? this.item.pdNo : this.item.mappBoxPdNo)
        const result = await this.addSpbk({
          spbkSeCd: this.spbkSeCd,
          pdNo, // 상품번호
          onldPdNo: '', // 온라인전용상품번호
          bunPdNo: this.item.bundle ? this.item.pdNo : '', // 세트상품일 때 세트상품번호
          spbkQy: this.item.pdTy !== '06' ? 1 : this.item.jpQy, // 장바구니 수량
          chnlCd: 'B2C',
          orMdiaCd: this.getMdiaSeCd(),
          inflPath: '',
          lsUpdrId: 'SCR_PDR_0001',
          exhPdNm: this.item.exhPdNm ? this.item.exhPdNm : '', // GTM 작업을 위한 파라미터 추가
          price: this.item.pdPrc ? this.item.pdPrc : '', // GTM 작업을 위한 파라미터 추가
          onlSclCd: this.item.onlSclCd ? this.item.onlSclCd : '', // GTM 작업을 위한 파라미터 추가
          brndNm: this.item.brndNm ? this.item.brndNm : '',
          variant: undefined, // GTM 작업을 위한 파라미터 추가
          pkgYn: this.item.pdTy !== '06' ? 'N' : 'Y', // 박스배송은 덕용여부Y로 넘겨주어야함.
        })
        this.showSpbkMsg(result.row, this.spbkSeCd) // 결과값에 따른 메시지 노출
      }
    },

    // 장바구니 메시지 노출
    showSpbkMsg (result, spbkSeCd) {
      let spbkSeCdNm = '택배배송'
      if (spbkSeCd === '02') {
        spbkSeCdNm = '매장픽업'
      } else if (spbkSeCd === '03') {
        spbkSeCdNm = '정기배송'
      } else if (spbkSeCd === '04') {
        spbkSeCdNm = '대량주문'
      } else if (spbkSeCd === '05') {
        spbkSeCdNm = '오늘배송'
      }
      if (result > 0) {
        // 장바구니에 상품을 담았습니다.(fo는 장바구니 이동 없음)
        this.openToast(spbkSeCdNm + ' ' + this.$t('PD.CART_SUCCESS'), { center: true, dangerouslyUseHTMLString: true })
      } else if (result === -1) {
        // 장바구니에 담을 수 있는 상품 개수를 초과했습니다.
        this.openToast(spbkSeCdNm + ' ' + this.$t('OR.OVER_COUNT_CART'), { center: true, dangerouslyUseHTMLString: true })
      } else {
        // 장바구니 담기가 불가합니다.
        this.$alert(this.$t('OR.CART_FAIL'), { center: true, dangerouslyUseHTMLString: true })
      }
    },
    delReWrhNtcn (data) {
      this.delPdData = []
      this.delPdData.push(data)
      this.$confirm(this.$t('PD.DELETE_RE_WRH_NTCN_PD_CONFIRM'), {
        cancelButtonText: '취소',
        confirmButtonText: '확인',
        dangerouslyUseHTMLString: true
      }).then(() => {
        try {
          this.$AxiosBuilder
            .data(this.delPdData)
            .build()
            .post('/pd/pdm/pdNtcn/delReWrhNtcn')
            .then((res) => {
              if (res.data.success) {
                if (res.data.data) {
                  this.$emit('reloadReWrhNtcn', res.data.data)
                }
              }
            })
        } catch (e) {
          console.log('SCR_PDM_0001 error : ', e)
        }
      }).catch(() => {
        // 취소버튼
      })
    },
    delStoreReWrhNtcn (data) {
      this.$emit('del-store-re-stock-pd', data)
    },
    opRunDelSelectedPd (data) {
      this.$emit('opRunDelSelectedPd', data)
    },
    setSpbkSeCd () {
      if (this.item.pdsOrPsblYn === 'Y') { // 택배 가능여부
        this.spbkSeCd = '01'
      } else if (this.item.pkupDdcatYn === 'Y' || this.item.pkupOrPsblYn === 'Y') { // 매장픽업
        this.spbkSeCd = '02'
      } else if (this.item.quickOrPsblYn === 'Y') { // 오늘배송
        this.spbkSeCd = '05'
      } else if (this.item.massOrPsblYn === 'Y') { // 대량배송
        this.spbkSeCd = '04'
      } else if (this.item.fdrmOrPsblYn === 'Y') { // 정기배송
        this.spbkSeCd = '03'
      }

      if (this.item.onlyOnlYn === true || this.item.onlyOnlYn === 'Y') {
        this.spbkSeCd = '01'
      } else if (this.item.onlyPkup === true || this.item.onlyPkup === 'Y') {
        this.spbkSeCd = '02'
      }
    }
  }
}
